import echarts from 'echarts';
export default {
    name: 'Chartsa',
    props: {
        chartData: {
            default: null,
        }
    },
    data() {
        return {
            chart1: null,
            myid: this.$getRandom(10),
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            window.onresize = () => {
                if (this.chart1) {
                    this.chart1.resize();
                }
            }
        },
        async init1() {
            let pieChart = echarts.init(document.getElementById(this.myid));
           // let data = [{name: '游泳健身', value: 250}, {name: '学车考驾照', value: 2048}, {name: '了解洗', value: 512}, {name: '呵呵', value: 512}, {name: '好啊', value: 512}]
            let data = this.chartData.data
            let sum = 0
            // 放置需要显示的图例(if you need)
            let legendData = []
            let showData=[]
            let total=''
            // 循环数据 累计sum值
                data.forEach(item => { 
                    if(item.name!='Total'){
                        legendData.push(item.name+item.detail) 
                        showData.push({name:item.name+item.detail,value:item.value})
                    }else{
                        total=item.detail
                    }
                })

                // 给数据加上总数sum 通过颜色及透明度设置不显示
              //  data.push({name: '总数', value: sum, itemStyle: {normal: {color: 'rgba(0, 0, 0, 0)'}}})


            // 绘制图表
            pieChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}<br/>{c}%'
                },
                legend:{
                    orient:'vertical',
                    x:'left',
                    y:'10%',
                    data:legendData
                },
                title: {
                    text:this.chartData.title,
                    subtext:'总计：'+total,
                    x:'center',
                    y:'top'
                },
                series: [ 
                    {
                        type: 'pie',
                        radius: '55%',
                        label: {
                            normal:{
                                position:'inner', 
                                 formatter: '{c}%',
                            },
                        },
                        data: showData,
                    }
                ]
            })

        },
        // 用于更新一些数据
        update() { },
    },
    // 计算属性
    computed: {
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() { },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        chartData() {
            this.init1();
            this.$nextTick(() => {
                this.init();
            });
        }
    },
    // 组件列表
    components: {},
};